import * as React from "react";
import { Card, Col, Row, Button, Collapse } from "antd";
import { DATA } from "../common/data";
import { Link } from "react-router-dom";
import {
  AlertTwoTone,
  CheckSquareTwoTone,
  ClockCircleTwoTone,
} from "@ant-design/icons";
import { IChapter, ILecture } from "../common/types";

const MainPage = () => {
  return (
    <>
      {DATA.map((chapter: IChapter) => {
        return (
          <Col xs={24} md={12} lg={8} key={chapter.url}>
            <Card bordered={false} style={{ margin: 20 }}>
              <h3>
                <AlertTwoTone twoToneColor="red" /> {chapter.title}
              </h3>
              <p>{chapter.description}</p>
              <Collapse ghost>
                <Collapse.Panel
                  header={`${chapter.lectures.length} 講座`}
                  key="講座"
                >
                  {chapter.lectures.map((lecture: ILecture) => {
                    return (
                      <div key={lecture.title}>
                        <CheckSquareTwoTone /> {lecture.title}
                      </div>
                    );
                  })}
                </Collapse.Panel>
              </Collapse>
              <p style={{ textAlign: "right" }}>
                <ClockCircleTwoTone /> {chapter.time} 分
              </p>
              <Row justify="space-around">
                <Link to={`/lectures/${chapter.url}`}>
                  <Button type="primary" size="large">
                    この講座を見る
                  </Button>
                </Link>
              </Row>
            </Card>
          </Col>
        );
      })}
    </>
  );
};

export default MainPage;
